module.exports = __webpack_public_path__ + "img/status_4.778c8083.svg";